export const Logo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 868.71 980"
    width={40}
    fill="var(--bs-light)"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M864.81,681.92a259.6,259.6,0,0,0-86.16-151,253.06,253.06,0,0,0-162.33-60.71c-100.22-.8-202.11-.71-300.64-.62-50.41,0-102.55.09-153.82,0-3.87,0-9.58.48-13.91,4.81s-4.85,10.2-4.84,14.22c.16,105.13.15,210.08-.05,311.94,0,4.47.54,10.15,4.86,14.46s10.24,4.86,14.29,4.83c61.46-.24,125.5-.25,195.78,0,3.8,0,9.41-.45,13.61-4.65s4.67-9.55,4.65-13.78c-.17-42.35-.15-85.41-.14-127.07q0-18.74,0-37.48c3.12.55,5.6,2.84,8.75,7.94,21.57,34.87,43.94,70,65.58,104,12.28,19.28,25,39.21,37.38,58.86,5.23,8.29,12.24,12.16,22.06,12.16H510c42.8-.17,86.32-.14,128.42-.12l36.42,0q8.79,0,17.57,0c12.53,0,25.48,0,38.24,0,9.38-.07,13.74-4.23,15.74-7.72s3.43-9.43-1.32-17.71c-.74-1.31-1.54-2.52-2.23-3.59-.3-.45-.6-.91-.89-1.37l-17.94-28.27Q653.74,650.23,583.44,539.4l7.93.1c18,.2,35,.39,51.36,3a185.51,185.51,0,0,1-28.57,368.67h-.1q-67.9,0-135.81,0H381.91q-155.91,0-311.81,0V70.32H203.16q158.79,0,317.59,0A151.53,151.53,0,0,1,672.24,230.13c-3.53,67.06-52.09,124.19-118.1,138.93-16.42,3.67-33,3.69-50.58,3.72-6.79,0-13.81,0-20.79.26-2.35.08-2.71.09-4.62-2.93-21.33-33.71-43.1-67.93-64.15-101-19.9-31.28-40.48-63.61-60.64-95.46-5.5-8.69-12.94-12.75-23.4-12.75h-.19c-41.66.2-84,.18-125,.16H163.38c-6.59,0-11.79,0-16,4.28s-4.16,9.43-4.16,16q0,120,0,240c0,7.19,0,12.39,4.17,16.69s9.73,4.43,16.61,4.43h73.54c93.38,0,189.93,0,284.9-.12a207.15,207.15,0,0,0,32.33-2.71,222.38,222.38,0,0,0,85.68-32.55,220.65,220.65,0,0,0,96.23-233.34C714.81,73.06,624.24,0,521.36,0H20.5C13.76,0,8.44,0,4.19,4.33S0,13.91,0,20.66V958.91c0,7.19,0,12.39,4.22,16.7S14,980,20.87,980H246.63c120.83,0,243.63,0,364.89-.13a292.3,292.3,0,0,0,40.67-3A243.86,243.86,0,0,0,747.58,942,259.55,259.55,0,0,0,861.64,784,245.4,245.4,0,0,0,864.81,681.92Zm-558,29.24v39.18H213.26V540.26H263.1c77.28,0,157.19,0,235.8-.14h0a6.31,6.31,0,0,1,1.86.17,6.19,6.19,0,0,1,1.26,1.6c36.23,57.18,73.21,115.22,109,171.34l23.51,36.9H611.87c-25.15,0-51.16,0-76.75.12l-.67,0c-.13-.17-.34-.45-.63-.9-15-23.55-30.23-47.47-45-70.6-20.68-32.41-42.06-65.93-63-99-5.69-9-13.2-13.13-23.62-12.95-17.72.25-35.78.2-53.25.16l-20.9,0c-7.25,0-12.49,0-16.81,4.18s-4.46,9.8-4.46,16.73Q306.82,649.52,306.83,711.16ZM213.27,231.39h20.88l17.09,0c17.9,0,36.41-.06,54.56.24a4.76,4.76,0,0,1,1.34.62c28,43.56,56.31,88,83.66,131l6.1,9.59H213.27Z" />
      </g>
    </g>
  </svg>
);

export const HI = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178.4 126.26">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M14.73,110.09V16.17H.5V.5H48.41V16.17H33.64V52H88.12V16.17H73.44V.5h47.91V16.17H107v93.92h14.32v15.67H73.44V110.09H88.12V67.68H33.64v42.41H48.41v15.67H.5V110.09Z"
        />
        <path
          className="cls-1"
          d="M145.49,110.09V16.17H132V.5H177.9V16.17H164.4v93.92h13.5v15.67H132V110.09Z"
        />
      </g>
    </g>
  </svg>
);

export const FlyIcon = (
  <svg width={50} viewBox="0 0 620.42 1332.99" fill="currentColor">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M319.5,166.73c-13.64-18.15-30.58-29-53.4-33.86.42-22.19,1-44.48,1.24-66.78.16-12.82-.15-25.64-.15-38.46C267.19,11.74,278.29,0,293.12,0,307.77,0,318.85,11.56,319,27.23q.48,67.18.76,134.37C319.73,162.86,319.62,164.12,319.5,166.73Z" />
        <path d="M158.3,1332.26c.15-2.45.47-4.9.44-7.35q-2.27-171-4.57-342c0-3.64,0-7.28,0-11.12l7,0q2.41,180.33,4.83,360.66l-7,.53Z" />
        <path d="M448.45,847.06a42.75,42.75,0,0,0-.38,5.28q4.67,101.35,9.39,202.72c.07,1.65.08,3.3.13,5.48l-7,.42c-3.33-71.47-6.64-142.61-10-214.1l7.14-.51Z" />
        <path d="M417,759.67c-17.82-6.78-35.44-14.25-53.56-20.2-23.4-7.7-47.47-12.26-72.31-9-28.41,3.77-49,18.54-58.11,45.93-9.55,28.62-28.91,47.65-54.45,61.56-31,16.86-64.68,25.22-99.15,30.9A561.62,561.62,0,0,1,0,876.08a33.8,33.8,0,0,1,.43-3.45c26.5-113.14,53.45-226.17,83.95-338.31,7.85-28.89,15.21-58,27-85.63,21.7-50.95,53.91-94.3,95.12-131.08,9.06-8.09,18.55-15.71,27.94-23.42a7,7,0,0,1,4.35-1.58c7,.34,13.91,1,20.39,1.47.41,12.9.15,26.22,1.37,39.4,3.5,37.83,13.09,74.4,24.3,110.55,26.47,85.38,61.7,167.27,99.55,248.08,10,21.39,20.59,42.52,30.89,63.77C415.93,757.2,416.48,758.57,417,759.67Z" />
        <path d="M620.42,631.75,489,736.17,407.82,634,434,613l-19.15-24.52,12.68-10.24,13.75,6.91L435.45,591l10.14,12.89,55.73-44.28L491,546.63l-6.43,4.83c-1.3-4.73-2.63-9.26-3.73-13.84a3.1,3.1,0,0,1,1-2.49c3.58-2.94,7.28-5.74,11.43-9l19.47,24.22,26.46-20.78Z" />
        <path d="M339.25,742.12c1.21,31.45,2.37,61.58,3.52,91.7,1.61,42.13,3.14,84.25,4.87,126.37.72,17.51-5.39,31.45-20.91,40.14C300.63,1015,268.68,997.26,267,967c-1.54-27.11-2.2-54.27-3.24-81.4-1.59-41.63-3-83.25-4.93-124.86-.24-5.42,1.75-8.25,5.78-10.85,11.9-7.65,25.13-10.78,39-10.51C315.31,739.62,327.05,741.13,339.25,742.12Z" />
        <path d="M429.67,567.93c-7.36-9.73-15.9-21-24.42-32.3q-35.76-47.46-71.51-94.93-28.86-38.28-57.7-76.57a12.17,12.17,0,0,1-2.27-5.42c-1.52-10.88-3-21.78-4-32.71a8.41,8.41,0,0,1,2.38-6,25.1,25.1,0,0,1,37.17,2.46c16.1,20.79,31.8,41.89,47.64,62.89q37.72,50,75.42,100.11c12.82,17,25.75,34,38.38,51.12,8.35,11.34,6.09,26.46-4.81,35.35C455.62,580.35,440.48,579.21,429.67,567.93Z" />
        <path d="M276.81,144.44c-5.12,7.55-10.05,14.84-15,22.11-5.4,7.95-7.68,16.61-5.42,26.08,4.35,18.29,25.68,24.47,41,11.88,11.29-9.26,15.62-21.14,12.52-35.8,21,20.48,20.66,63.8-.44,90-23.59,29.26-65.31,35.59-97.21,14.77-30.68-20-41.27-61.29-24.16-94.12C204.87,147.27,244.29,131.49,276.81,144.44Z" />
        <path d="M319.46,458.43l10-10c31,41.16,61.83,82,93,123.36L403.5,587.21l19.2,24.39-26.18,21,20.17,25.65a35.43,35.43,0,0,1-3.75,1.18c-22.68,4.21-44-11.82-47.16-35.83-3.52-26.41-6.77-52.86-10.15-79.29-.21-1.58-.53-3.14-.93-5.44l-18.49,18.49c-23-57.55-43.92-115-56.85-175.31,6.29,8.29,12.61,16.56,18.88,24.87,4.91,6.51,9.42,13.36,14.73,19.53a22.38,22.38,0,0,1,5.73,16.34C318.53,447.55,319.13,452.33,319.46,458.43Z" />
        <path d="M442.5,1194.92l-7.15.38c-4.77-102.49-9.53-204.74-14.31-307.38l7.16-.32C433,990,437.72,1092.14,442.5,1194.92Z" />
        <path d="M174.87,924.39l7.17-.07c1.12,83.87,2.24,167.53,3.36,251.49l-7.16.07C177.12,1092,176,1008.48,174.87,924.39Z" />
        <path d="M141.73,1124l-7.16.09c-1.12-83.85-2.25-167.38-3.37-251.33l7.16-.26C139.48,956.32,140.6,1039.93,141.73,1124Z" />
        <path d="M402.78,803.76c3.33,71.51,6.64,142.64,10,214.19l-7.16.31c-3.33-71.45-6.64-142.57-10-214.11Z" />
        <path d="M295.39,195.59c-1.39,1.22-2.34,2.16-3.39,3-6.67,5.11-15.4,5.82-21.46,1.79-5.63-3.74-8.28-11.64-6.26-19.65a28.21,28.21,0,0,1,3.36-8.25c4.48-7,9.35-13.71,14-20.62,2.07-3.1,4.54-3.67,7.6-1.68a73.5,73.5,0,0,1,7,4.83,7.86,7.86,0,0,1,2.3,3.62c1.18,3.87,1.91,7.88,3.16,11.73C304.86,180.32,301.68,188.54,295.39,195.59Z" />
        <path d="M318.18,320.34c-17.58-17.75-26.87-19.8-49.34-9.13.4-5.95.64-11.56,1.26-17.12a4.26,4.26,0,0,1,2.69-2.77c19.42-5.14,34.82-16,46.68-32.5C319,280,318.59,300.9,318.18,320.34Z" />
        <path d="M67.37,371.79l7.14-.3c.52,10.79,1,21.24,1.52,31.69,1.51,32.62,2.74,65.26,4.7,97.85.58,9.7-2.58,18.21-6.06,27.1C72.24,476.12,69.81,424.11,67.37,371.79Z" />
        <path d="M87,330.56l7.13-.19c.62,12.88,1.23,25.48,1.82,38.07,1.15,24.47,1.93,49,3.6,73.4.6,8.79-2.14,16.22-6.25,23.84C91.18,420.81,89.09,376,87,330.56Z" />
        <path d="M426.61,464.41l-40.72-54C404.9,403.27,425.41,430,426.61,464.41Z" />
      </g>
    </g>
  </svg>
);

export const MeditationIcon = (
  <svg
    width="28"
    height="30"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.2862 25.5219C26.8803 25.0473 25.9312 23.1493 25.9312 23.1493C25.9312 23.1493 26.0879 22.9473 25.9312 22.2674C25.7272 21.3865 24.8463 21.4538 24.6434 21.2509C24.4395 21.0475 22.6776 17.8276 22.542 17.4545C22.4064 17.0813 20.9148 12.8454 20.9148 12.8454C20.4138 10.642 19.4905 9.72697 18.271 9.45574C17.0616 9.18732 16.4067 9.25236 15.8642 8.77775C15.5257 8.48162 15.5377 8.2616 15.5377 7.36822C15.5377 7.36822 15.903 7.02094 16.1696 6.54076C16.4739 5.99145 16.6234 5.19855 16.6234 5.19855C16.9288 5.07633 16.9324 4.9241 17.0643 4.43889C17.247 3.76734 17.2341 3.30703 16.7461 3.30703C16.8615 1.11715 15.7628 0 14 0C12.2381 0 11.1394 1.11715 11.2547 3.30709C10.7667 3.30709 10.7529 3.7674 10.9364 4.43895C11.0683 4.92416 11.072 5.07639 11.3765 5.19861C11.3765 5.19861 11.5259 5.9915 11.8313 6.54082C12.0979 7.02094 12.4631 7.36828 12.4631 7.36828C12.4631 8.26166 12.4742 8.48168 12.1357 8.77781C11.5941 9.25242 10.9383 9.18738 9.72986 9.4558C8.50947 9.72697 7.58697 10.6421 7.08611 12.8454C7.08611 12.8454 5.59449 17.0814 5.45891 17.4546C5.32332 17.8277 3.56041 21.0475 3.3575 21.251C3.15453 21.4539 2.2727 21.3865 2.06973 22.2675C1.91293 22.9474 2.06973 23.1494 2.06973 23.1494C2.06973 23.1494 1.12051 25.0474 0.713691 25.522C0.306934 25.9961 1.05318 26.3351 1.52732 25.7249C1.58264 25.8075 1.77084 25.867 1.98395 25.8956C0.329961 27.7267 1.27273 30.1122 3.83258 29.996C5.93111 29.9004 14 28.4365 14 28.4365C14 28.4365 22.0688 29.9004 24.1684 29.9959C26.7282 30.1121 27.671 27.7266 26.0161 25.8955C26.23 25.8669 26.4182 25.8074 26.4736 25.7249C26.9477 26.3351 27.6931 25.9961 27.2862 25.5219ZM9.72986 22.4912C9.72986 22.4912 6.25678 23.5239 4.09361 24.4971C4.53916 23.6677 5.05203 22.5387 5.05203 22.5387L7.2217 19.4208L8.95045 15.658C8.95045 15.658 9.49285 17.692 9.66166 17.9969C9.83135 18.3018 9.72986 22.4912 9.72986 22.4912ZM18.271 22.4912C18.271 22.4912 18.1695 18.3018 18.3383 17.9969C18.508 17.692 19.0504 15.658 19.0504 15.658L20.7792 19.4208L22.9479 22.5387C22.9479 22.5387 23.4617 23.6678 23.9073 24.4971C21.744 23.5239 18.271 22.4912 18.271 22.4912Z"
      fill="currentColor"
    />
  </svg>
);

export const FooterLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 868.71 980"
    width={80}
    fill="var(--bs-primary)"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M864.81,681.92a259.6,259.6,0,0,0-86.16-151,253.06,253.06,0,0,0-162.33-60.71c-100.22-.8-202.11-.71-300.64-.62-50.41,0-102.55.09-153.82,0-3.87,0-9.58.48-13.91,4.81s-4.85,10.2-4.84,14.22c.16,105.13.15,210.08-.05,311.94,0,4.47.54,10.15,4.86,14.46s10.24,4.86,14.29,4.83c61.46-.24,125.5-.25,195.78,0,3.8,0,9.41-.45,13.61-4.65s4.67-9.55,4.65-13.78c-.17-42.35-.15-85.41-.14-127.07q0-18.74,0-37.48c3.12.55,5.6,2.84,8.75,7.94,21.57,34.87,43.94,70,65.58,104,12.28,19.28,25,39.21,37.38,58.86,5.23,8.29,12.24,12.16,22.06,12.16H510c42.8-.17,86.32-.14,128.42-.12l36.42,0q8.79,0,17.57,0c12.53,0,25.48,0,38.24,0,9.38-.07,13.74-4.23,15.74-7.72s3.43-9.43-1.32-17.71c-.74-1.31-1.54-2.52-2.23-3.59-.3-.45-.6-.91-.89-1.37l-17.94-28.27Q653.74,650.23,583.44,539.4l7.93.1c18,.2,35,.39,51.36,3a185.51,185.51,0,0,1-28.57,368.67h-.1q-67.9,0-135.81,0H381.91q-155.91,0-311.81,0V70.32H203.16q158.79,0,317.59,0A151.53,151.53,0,0,1,672.24,230.13c-3.53,67.06-52.09,124.19-118.1,138.93-16.42,3.67-33,3.69-50.58,3.72-6.79,0-13.81,0-20.79.26-2.35.08-2.71.09-4.62-2.93-21.33-33.71-43.1-67.93-64.15-101-19.9-31.28-40.48-63.61-60.64-95.46-5.5-8.69-12.94-12.75-23.4-12.75h-.19c-41.66.2-84,.18-125,.16H163.38c-6.59,0-11.79,0-16,4.28s-4.16,9.43-4.16,16q0,120,0,240c0,7.19,0,12.39,4.17,16.69s9.73,4.43,16.61,4.43h73.54c93.38,0,189.93,0,284.9-.12a207.15,207.15,0,0,0,32.33-2.71,222.38,222.38,0,0,0,85.68-32.55,220.65,220.65,0,0,0,96.23-233.34C714.81,73.06,624.24,0,521.36,0H20.5C13.76,0,8.44,0,4.19,4.33S0,13.91,0,20.66V958.91c0,7.19,0,12.39,4.22,16.7S14,980,20.87,980H246.63c120.83,0,243.63,0,364.89-.13a292.3,292.3,0,0,0,40.67-3A243.86,243.86,0,0,0,747.58,942,259.55,259.55,0,0,0,861.64,784,245.4,245.4,0,0,0,864.81,681.92Zm-558,29.24v39.18H213.26V540.26H263.1c77.28,0,157.19,0,235.8-.14h0a6.31,6.31,0,0,1,1.86.17,6.19,6.19,0,0,1,1.26,1.6c36.23,57.18,73.21,115.22,109,171.34l23.51,36.9H611.87c-25.15,0-51.16,0-76.75.12l-.67,0c-.13-.17-.34-.45-.63-.9-15-23.55-30.23-47.47-45-70.6-20.68-32.41-42.06-65.93-63-99-5.69-9-13.2-13.13-23.62-12.95-17.72.25-35.78.2-53.25.16l-20.9,0c-7.25,0-12.49,0-16.81,4.18s-4.46,9.8-4.46,16.73Q306.82,649.52,306.83,711.16ZM213.27,231.39h20.88l17.09,0c17.9,0,36.41-.06,54.56.24a4.76,4.76,0,0,1,1.34.62c28,43.56,56.31,88,83.66,131l6.1,9.59H213.27Z" />
      </g>
    </g>
  </svg>
);

export const LinkedinIcon = (
  <svg
    width="30px"
    height="30px"
    viewBox="-271 283.9 256 235.1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#b4b4b4"
  >
    <title>linkedin</title>
    <rect x="-264.4" y="359.3" width="49.9" height="159.7" />
    <path
      d="M-240.5,283.9c-18.4,0-30.5,11.9-30.5,27.7c0,15.5,11.7,27.7,29.8,27.7h0.4c18.8,0,30.5-12.3,30.4-27.7
C-210.8,295.8-222.1,283.9-240.5,283.9z"
    />
    <path
      d="M-78.2,357.8c-28.6,0-46.5,15.6-49.8,26.6v-25.1h-56.1c0.7,13.3,0,159.7,0,159.7h56.1v-86.3c0-4.9-0.2-9.7,1.2-13.1
c3.8-9.6,12.1-19.6,27-19.6c19.5,0,28.3,14.8,28.3,36.4V519h56.6v-88.8C-14.9,380.8-42.7,357.8-78.2,357.8z"
    />
  </svg>
);

export const MailIcon = (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="#b4b4b4"
  >
    <title>mail</title>
    <polygon className="st0" points="512,295.199 445.92,226.559 512,169.6 	" />
    <polygon className="st0" points="66.16,226.559 0,295.279 0,169.6 	" />
    <path
      className="st0"
      d="M512,357.6v63.199c0,15.281-12.4,27.682-27.68,27.682H27.68c-15.281,0-27.68-12.4-27.68-27.682V357.6
		l98.959-102.721L212,352.238c11.76,10.082,27.359,15.682,44,15.682c16.641,0,32.32-5.6,44.08-15.682l112.959-97.359L512,357.6z"
    />
    <path
      className="st0"
      d="M512,91.119v27.68l-241.442,208c-7.76,6.72-21.359,6.72-29.119,0L0,118.799v-27.68
		c0-15.279,12.398-27.6,27.68-27.6H484.32C499.6,63.519,512,75.84,512,91.119z"
    />
  </svg>
);

export const MoonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    className="bi bi-moon"
    viewBox="0 0 16 16"
  >
    <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278M4.858 1.311A7.27 7.27 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.32 7.32 0 0 0 5.205-2.162q-.506.063-1.029.063c-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286" />
  </svg>
);

export const SunIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    className="bi bi-sun"
    viewBox="0 0 16 16"
  >
    <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
  </svg>
);

export const WordpressIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 512 512"
    fill="#21759b"
  >
    <g>
      <path
        className="st0"
        d="M256.004,0C114.8,0.008,0.025,114.801,0,255.996C0.025,397.183,114.8,511.975,256.004,512
      C397.191,511.975,511.984,397.183,512,255.996C511.984,114.801,397.191,0.008,256.004,0z M420.735,420.72
      c-42.256,42.241-100.456,68.354-164.731,68.362c-64.284-0.008-122.491-26.121-164.732-68.362
      c-42.24-42.241-68.345-100.456-68.354-164.724c0.008-64.276,26.114-122.475,68.354-164.731
      C133.513,49.04,191.72,22.927,256.004,22.918c64.276,0.008,122.475,26.122,164.731,68.346
      c42.224,42.256,68.338,100.447,68.346,164.731C489.073,320.264,462.96,378.479,420.735,420.72z"
      />
      <path
        className="st0"
        d="M72.03,173.859h-1.445c-11.141,25.118-17.37,52.885-17.37,82.137c0,79.817,46.109,148.821,113.138,181.918
      L72.039,173.859H72.03z"
      />
      <path
        className="st0"
        d="M371.166,182.392c-17.484-24.452-14.891-74.438,17.26-79.914c-35.538-30.672-81.8-49.272-132.421-49.272
      c-71.894,0-135.006,37.432-171.017,93.857h74.23v26.795h-29.919l69.269,193.887l48.59-129.884l-22.878-64.004h-34.607v-26.795
      h124.225v26.795h-32.358l69.855,195.573l35.401-94.572C393.073,249.366,389.404,207.967,371.166,182.392z"
      />
      <path
        className="st0"
        d="M444.513,181.277c-0.08,0.77-0.16,1.549-0.273,2.304c-4.905,32.92-35.394,105.127-35.394,105.127
      l-44.143,117.996l-9.849,26.346c62.004-34.686,103.939-100.946,103.939-177.054C458.794,229.594,453.696,204.404,444.513,181.277z"
      />
      <path
        className="st0"
        d="M211.861,404.962l-16.665,44.537c19.202,6.036,39.616,9.287,60.808,9.287c23.16,0,45.388-3.925,66.122-11.086
      l-61.675-172.654L211.861,404.962z"
      />
    </g>
  </svg>
);

export const JsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50px"
    height="50px"
    viewBox="0 0 256 256"
    className="mt-auto mb-auto skill-logo skill-logo-js"
  >
    <path d="M0 0h256v256H0V0z" fill="#F7DF1E" />
    <path d="M67.312 213.932l19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371 7.905 0 12.89-3.092 12.89-15.12v-81.798h24.057v82.138c0 24.917-14.606 36.259-35.916 36.259-19.245 0-30.416-9.967-36.087-21.996M152.381 211.354l19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607 9.969 0 16.325-4.984 16.325-11.858 0-8.248-6.53-11.17-17.528-15.98l-6.013-2.58c-17.357-7.387-28.87-16.667-28.87-36.257 0-18.044 13.747-31.792 35.228-31.792 15.294 0 26.292 5.328 34.196 19.247L210.29 147.43c-4.125-7.389-8.591-10.31-15.465-10.31-7.046 0-11.514 4.468-11.514 10.31 0 7.217 4.468 10.14 14.778 14.608l6.014 2.577c20.45 8.765 31.963 17.7 31.963 37.804 0 21.654-17.012 33.51-39.867 33.51-22.339 0-36.774-10.654-43.819-24.574" />
  </svg>
);

export const ReactIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 32 32"
    fill="#61dafb"
  >
    <path d="M18.6789 15.9759C18.6789 14.5415 17.4796 13.3785 16 13.3785C14.5206 13.3785 13.3211 14.5415 13.3211 15.9759C13.3211 17.4105 14.5206 18.5734 16 18.5734C17.4796 18.5734 18.6789 17.4105 18.6789 15.9759Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.7004 11.1537C25.2661 8.92478 25.9772 4.79148 23.4704 3.39016C20.9753 1.99495 17.7284 4.66843 16.0139 6.27318C14.3044 4.68442 10.9663 2.02237 8.46163 3.42814C5.96751 4.82803 6.73664 8.8928 7.3149 11.1357C4.98831 11.7764 1 13.1564 1 15.9759C1 18.7874 4.98416 20.2888 7.29698 20.9289C6.71658 23.1842 5.98596 27.1909 8.48327 28.5877C10.9973 29.9932 14.325 27.3945 16.0554 25.7722C17.7809 27.3864 20.9966 30.0021 23.4922 28.6014C25.9956 27.1963 25.3436 23.1184 24.7653 20.8625C27.0073 20.221 31 18.7523 31 15.9759C31 13.1835 26.9903 11.7923 24.7004 11.1537ZM24.4162 19.667C24.0365 18.5016 23.524 17.2623 22.8971 15.9821C23.4955 14.7321 23.9881 13.5088 24.3572 12.3509C26.0359 12.8228 29.7185 13.9013 29.7185 15.9759C29.7185 18.07 26.1846 19.1587 24.4162 19.667ZM22.85 27.526C20.988 28.571 18.2221 26.0696 16.9478 24.8809C17.7932 23.9844 18.638 22.9422 19.4625 21.7849C20.9129 21.6602 22.283 21.4562 23.5256 21.1777C23.9326 22.7734 24.7202 26.4763 22.85 27.526ZM9.12362 27.5111C7.26143 26.47 8.11258 22.8946 8.53957 21.2333C9.76834 21.4969 11.1286 21.6865 12.5824 21.8008C13.4123 22.9332 14.2816 23.9741 15.1576 24.8857C14.0753 25.9008 10.9945 28.557 9.12362 27.5111ZM2.28149 15.9759C2.28149 13.874 5.94207 12.8033 7.65904 12.3326C8.03451 13.5165 8.52695 14.7544 9.12123 16.0062C8.51925 17.2766 8.01977 18.5341 7.64085 19.732C6.00369 19.2776 2.28149 18.0791 2.28149 15.9759ZM9.1037 4.50354C10.9735 3.45416 13.8747 6.00983 15.1159 7.16013C14.2444 8.06754 13.3831 9.1006 12.5603 10.2265C11.1494 10.3533 9.79875 10.5569 8.55709 10.8297C8.09125 9.02071 7.23592 5.55179 9.1037 4.50354ZM20.3793 11.5771C21.3365 11.6942 22.2536 11.85 23.1147 12.0406C22.8562 12.844 22.534 13.6841 22.1545 14.5453C21.6044 13.5333 21.0139 12.5416 20.3793 11.5771ZM16.0143 8.0481C16.6054 8.66897 17.1974 9.3623 17.7798 10.1145C16.5985 10.0603 15.4153 10.0601 14.234 10.1137C14.8169 9.36848 15.414 8.67618 16.0143 8.0481ZM9.8565 14.5444C9.48329 13.6862 9.16398 12.8424 8.90322 12.0275C9.75918 11.8418 10.672 11.69 11.623 11.5748C10.9866 12.5372 10.3971 13.5285 9.8565 14.5444ZM11.6503 20.4657C10.6679 20.3594 9.74126 20.2153 8.88556 20.0347C9.15044 19.2055 9.47678 18.3435 9.85796 17.4668C10.406 18.4933 11.0045 19.4942 11.6503 20.4657ZM16.0498 23.9915C15.4424 23.356 14.8365 22.6531 14.2448 21.8971C15.4328 21.9423 16.6231 21.9424 17.811 21.891C17.2268 22.6608 16.6369 23.3647 16.0498 23.9915ZM22.1667 17.4222C22.5677 18.3084 22.9057 19.1657 23.1742 19.9809C22.3043 20.1734 21.3652 20.3284 20.3757 20.4435C21.015 19.4607 21.6149 18.4536 22.1667 17.4222ZM18.7473 20.5941C16.9301 20.72 15.1016 20.7186 13.2838 20.6044C12.2509 19.1415 11.3314 17.603 10.5377 16.0058C11.3276 14.4119 12.2404 12.8764 13.2684 11.4158C15.0875 11.2825 16.9178 11.2821 18.7369 11.4166C19.7561 12.8771 20.6675 14.4086 21.4757 15.9881C20.6771 17.5812 19.7595 19.1198 18.7473 20.5941ZM22.8303 4.4666C24.7006 5.51254 23.8681 9.22726 23.4595 10.8426C22.2149 10.5641 20.8633 10.3569 19.4483 10.2281C18.6239 9.09004 17.7698 8.05518 16.9124 7.15949C18.1695 5.98441 20.9781 3.43089 22.8303 4.4666Z"
    />
  </svg>
);

export const NextjsIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 16 16"
    fill="#b4b4b4"
  >
    <path d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C9.35329 14.5 10.6088 14.0871 11.6492 13.3799L6 6.57712V11.25C6 11.6642 5.66421 12 5.25 12C4.83579 12 4.5 11.6642 4.5 11.25V4.5C4.5 4.184 4.69807 3.9019 4.99529 3.79458C5.29251 3.68726 5.62511 3.77775 5.82699 4.02085L13.3008 13.0209C13.5622 13.3357 13.523 13.802 13.2127 14.0687C11.813 15.272 9.99057 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 8.76428 15.8926 9.50473 15.6916 10.2065C15.5936 10.5489 15.4733 10.8818 15.3325 11.2037C15.1665 11.5832 14.7243 11.7562 14.3448 11.5902C13.9653 11.4242 13.7922 10.982 13.9583 10.6025C14.0725 10.3413 14.1701 10.0712 14.2496 9.79351C14.4125 9.2247 14.5 8.6232 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM10.5 3.75C10.9142 3.75 11.25 4.08579 11.25 4.5V7.5C11.25 7.91421 10.9142 8.25 10.5 8.25C10.0858 8.25 9.75 7.91421 9.75 7.5V4.5C9.75 4.08579 10.0858 3.75 10.5 3.75Z" />
  </svg>
);

export const JqueryIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 512 512"
    fill="#0773b4"
  >
    <path
      d="M499.161,364.63c0,0-63.554,171.386-282.354,131.488c-3.443-0.641-6.745-1.838-10.089-2.849
		c-0.782-0.229-1.572-0.479-2.354-0.703c-3.285-1.022-6.537-2.07-9.769-3.197c-0.37-0.129-0.723-0.25-1.098-0.383
		c-2.944-1.035-5.872-2.134-8.762-3.244c-0.757-0.295-1.51-0.582-2.263-0.89c-3.114-1.23-6.212-2.516-9.277-3.859
		c-0.565-0.249-1.11-0.499-1.684-0.752c-2.683-1.193-5.332-2.429-7.959-3.685c-0.682-0.346-1.368-0.666-2.055-0.99
		c-0.374-0.187-0.777-0.374-1.16-0.565c-1.696-0.848-3.352-1.729-5.023-2.604c-1.289-0.665-2.599-1.313-3.88-2
		c-2.366-1.289-4.699-2.599-7.02-3.938c-0.861-0.491-1.73-0.965-2.583-1.46c-3.152-1.854-6.271-3.78-9.344-5.727
		c-0.869-0.557-1.729-1.147-2.586-1.722c-2.004-1.297-4.009-2.595-5.972-3.95c-0.208-0.142-0.407-0.291-0.611-0.437
		c-0.761-0.516-1.484-1.044-2.241-1.593c-2.071-1.439-4.121-2.911-6.15-4.408c-0.981-0.74-1.959-1.484-2.932-2.229
		c-1.838-1.402-3.667-2.837-5.481-4.284c-0.902-0.723-1.817-1.438-2.719-2.17c-2.212-1.822-4.417-3.677-6.575-5.548
		c-0.408-0.357-0.84-0.707-1.256-1.081c-0.042-0.017-0.071-0.05-0.117-0.088c-2.449-2.146-4.853-4.346-7.236-6.591
		c-0.719-0.657-1.435-1.36-2.158-2.05c-1.78-1.71-3.543-3.432-5.277-5.178c-0.72-0.707-1.431-1.422-2.121-2.138
		c-2.241-2.304-4.454-4.611-6.616-6.97c-0.079-0.107-0.158-0.17-0.253-0.274c-0.038-0.041-0.092-0.096-0.129-0.142
		c-2.212-2.437-4.383-4.928-6.508-7.427c-0.595-0.703-1.193-1.422-1.78-2.133c-1.584-1.909-3.144-3.813-4.674-5.743
		c-0.636-0.803-1.272-1.613-1.9-2.42c-1.717-2.217-3.414-4.45-5.057-6.721c-0.308-0.424-0.636-0.84-0.932-1.256
		c-0.063-0.07-0.116-0.146-0.158-0.216c-1.904-2.633-3.742-5.315-5.547-8.001c-0.561-0.824-1.089-1.672-1.63-2.521
		c-1.306-1.987-2.587-3.976-3.826-5.988c-0.648-1.031-1.264-2.066-1.888-3.103c-1.127-1.879-2.229-3.759-3.298-5.655
		c-0.611-1.073-1.214-2.121-1.805-3.223c-0.329-0.582-0.686-1.182-1.006-1.792c-0.562-1.016-1.069-2.075-1.618-3.111
		c-0.848-1.626-1.709-3.26-2.528-4.915c-34.557-69.094-40.196-153.694,5.048-218.723l35.314-44.789
		c-39.843,77.007-21.936,170.778,27.908,238.76c1.8,2.475,3.643,4.916,5.526,7.356c0.583,0.736,1.168,1.477,1.751,2.184
		c1.567,1.996,3.168,3.967,4.786,5.918c0.583,0.686,1.152,1.359,1.747,2.066c2.163,2.554,4.375,5.09,6.646,7.564
		c0.108,0.12,0.212,0.229,0.316,0.345c2.146,2.342,4.333,4.653,6.558,6.933c0.69,0.698,1.393,1.389,2.096,2.088
		c1.747,1.783,3.531,3.514,5.344,5.235c0.686,0.682,1.376,1.339,2.088,2.017c2.449,2.279,4.919,4.545,7.435,6.758
		c0.262,0.229,0.532,0.44,0.773,0.652c2.329,2.025,4.687,3.997,7.074,5.96c0.832,0.678,1.68,1.355,2.528,2.029
		c1.875,1.509,3.772,2.978,5.681,4.437c0.911,0.699,1.846,1.41,2.791,2.108c2.075,1.539,4.171,3.053,6.288,4.55
		c0.719,0.486,1.418,1.015,2.146,1.505c2.188,1.514,4.417,2.986,6.654,4.425c0.84,0.558,1.672,1.14,2.52,1.681
		c3.086,1.954,6.205,3.875,9.357,5.73c0.811,0.466,1.622,0.902,2.42,1.352c2.379,1.376,4.762,2.731,7.19,4.029
		c1.314,0.731,2.666,1.393,3.996,2.096c1.988,1.023,3.976,2.063,5.988,3.044c0.761,0.374,1.501,0.724,2.246,1.077
		c2.566,1.235,5.14,2.425,7.743,3.605c0.616,0.267,1.214,0.545,1.834,0.811c3.032,1.327,6.096,2.6,9.186,3.817
		c0.794,0.316,1.589,0.62,2.387,0.937c2.811,1.089,5.643,2.146,8.508,3.156c0.445,0.158,0.89,0.32,1.322,0.478
		c3.194,1.099,6.408,2.146,9.648,3.136c0.827,0.258,1.655,0.508,2.503,0.757c3.318,0.981,6.616,2.042,10.018,2.812
		C351.039,452.521,445.783,434.173,499.161,364.63z M182.44,254.758c4.907,7.024,10.338,15.386,16.846,21.031
		c2.354,2.598,4.824,5.13,7.34,7.621c0.632,0.648,1.285,1.272,1.938,1.908c2.437,2.371,4.932,4.704,7.494,6.97
		c0.108,0.079,0.204,0.188,0.308,0.263c0.029,0.033,0.054,0.041,0.075,0.074c2.845,2.487,5.781,4.887,8.758,7.244
		c0.662,0.508,1.318,1.036,1.988,1.552c2.99,2.291,6.039,4.545,9.166,6.69c0.096,0.066,0.17,0.134,0.266,0.2
		c1.376,0.956,2.782,1.846,4.175,2.761c0.674,0.433,1.31,0.898,1.983,1.306c2.237,1.435,4.496,2.828,6.795,4.167
		c0.325,0.2,0.641,0.366,0.961,0.553c1.975,1.14,3.992,2.267,6.005,3.356c0.698,0.391,1.414,0.74,2.129,1.114
		c1.389,0.724,2.786,1.468,4.2,2.171c0.212,0.1,0.433,0.199,0.637,0.287c2.882,1.418,5.788,2.79,8.762,4.079
		c0.632,0.283,1.289,0.532,1.934,0.799c2.375,1.006,4.77,1.992,7.178,2.915c1.022,0.387,2.059,0.757,3.073,1.127
		c2.191,0.815,4.383,1.556,6.595,2.296c1.003,0.319,1.984,0.648,2.986,0.956c3.144,0.973,6.254,2.212,9.535,2.753
		C472.501,366.942,511.5,236.873,511.5,236.873c-35.16,50.633-103.243,74.791-175.897,55.936c-3.223-0.849-6.403-1.776-9.56-2.77
		c-0.974-0.292-1.922-0.607-2.883-0.928c-2.245-0.728-4.479-1.501-6.694-2.308c-1.011-0.37-2.025-0.74-3.02-1.123
		c-2.425-0.932-4.824-1.896-7.198-2.902c-0.653-0.283-1.306-0.533-1.942-0.824c-2.981-1.299-5.917-2.663-8.812-4.094
		c-1.493-0.729-2.953-1.499-4.425-2.254c-0.849-0.437-1.701-0.875-2.549-1.312c-1.88-1.021-3.751-2.08-5.594-3.154
		c-0.437-0.252-0.894-0.491-1.339-0.755c-2.283-1.339-4.537-2.718-6.77-4.134c-0.687-0.438-1.352-0.915-2.038-1.366
		c-1.477-0.954-2.944-1.921-4.392-2.902c-3.11-2.146-6.138-4.399-9.128-6.678c-0.69-0.543-1.376-1.073-2.059-1.616
		c-31.796-25.111-57-59.423-68.994-98.33c-12.555-40.352-9.847-85.647,11.914-122.406l-26.735,37.738
		c-32.715,47.085-30.939,110.113-5.419,159.91C172.252,238.95,177.063,247.046,182.44,254.758z M360.5,196.506
		c1.393,0.52,2.782,0.981,4.191,1.458c0.616,0.189,1.231,0.401,1.851,0.584c1.988,0.626,3.963,1.352,6.018,1.738
		c93.284,18.023,118.58-47.869,125.317-57.566c-22.165,31.91-59.405,39.57-105.111,28.481c-3.605-0.881-7.572-2.185-11.058-3.416
		c-4.462-1.591-8.849-3.404-13.124-5.456c-8.121-3.899-15.848-8.629-23.025-14.045c-40.891-31.029-66.291-90.221-39.61-138.425
		L291.51,29.76c-19.287,28.386-21.179,63.638-7.801,94.991C297.823,158.025,326.745,184.132,360.5,196.506z"
    ></path>
  </svg>
);

export const HtmlIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 512 512"
    fill="#fc490b"
  >
    <path
      display="inline"
      d="M30.713,0.501L71.717,460.42l184.006,51.078l184.515-51.15L481.287,0.501H30.713z M395.754,109.646
		l-2.567,28.596l-1.128,12.681h-0.187H256h-0.197h-79.599l5.155,57.761h74.444H256h115.723h15.201l-1.377,15.146l-13.255,148.506
		l-0.849,9.523L256,413.854v0.012l-0.259,0.072l-115.547-32.078l-7.903-88.566h26.098h30.526l4.016,44.986l62.82,16.965l0.052-0.014
		v-0.006l62.916-16.977l6.542-73.158H256h-0.197H129.771l-13.863-155.444l-1.351-15.131h141.247H256h141.104L395.754,109.646z"
    ></path>
  </svg>
);

export const CssIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 32 32"
    fill="#1775bb"
  >
    <path d="M24.235 6.519l-16.47-0.004 0.266 3.277 12.653 0.002-0.319 3.394h-8.298l0.3 3.215h7.725l-0.457 4.403-3.636 1.005-3.694-1.012-0.235-2.637h-3.262l0.362 4.817 6.829 2.128 6.714-1.912 1.521-16.675zM2.879 1.004h26.242l-2.387 26.946-10.763 3.045-10.703-3.047z"></path>
  </svg>
);

export const BootstrapIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 24 24"
    fill="#8612fa"
  >
    <path d="M4.98488 2C3.61546 2 2.60217 3.19858 2.64753 4.49844C2.69105 5.74725 2.63451 7.36461 2.22732 8.68359C1.81892 10.0064 1.1282 10.8444 0 10.952V12.1666C1.1282 12.2742 1.81892 13.1122 2.22732 14.4351C2.63451 15.754 2.69105 17.3714 2.64753 18.6202C2.60217 19.9199 3.61546 21.1186 4.98508 21.1186H19.0169C20.3864 21.1186 21.3995 19.9201 21.3541 18.6202C21.3106 17.3714 21.3671 15.754 21.7743 14.4351C22.1829 13.1122 22.8718 12.2742 24 12.1666V10.952C22.8718 10.8444 22.1829 10.0064 21.7743 8.68359C21.3671 7.36481 21.3106 5.74725 21.3541 4.49844C21.3995 3.19878 20.3864 2 19.0169 2H4.98468H4.98488ZM16.2712 13.7687C16.2712 15.5586 14.9361 16.6441 12.7206 16.6441H8.94915C8.84127 16.6441 8.7378 16.6012 8.66152 16.5249C8.58523 16.4486 8.54237 16.3452 8.54237 16.2373V6.88136C8.54237 6.77347 8.58523 6.67001 8.66152 6.59372C8.7378 6.51743 8.84127 6.47458 8.94915 6.47458H12.6991C14.5464 6.47458 15.7588 7.47525 15.7588 9.01166C15.7588 10.09 14.9433 11.0555 13.9041 11.2245V11.2809C15.3187 11.4361 16.2712 12.4156 16.2712 13.7687ZM12.3094 7.76407H10.1589V10.8015H11.9701C13.3702 10.8015 14.1423 10.2377 14.1423 9.2299C14.1423 8.28556 13.4784 7.76407 12.3094 7.76407ZM10.1589 12.0068V15.3542H12.3885C13.8462 15.3542 14.6184 14.7692 14.6184 13.6699C14.6184 12.5704 13.8246 12.0066 12.2947 12.0066H10.1589V12.0068Z" />
  </svg>
);

export const FigmaIcon = (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 300"
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
  >
    <title>Figma.logo</title>
    <desc>Created using Figma</desc>
    <path
      fill="#0acf83"
      d="M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z"
    />
    <path
      fill="#a259ff"
      d="M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z"
    />
    <path
      fill="#f24e1e"
      d="M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z"
    />
    <path
      fill="#ff7262"
      d="M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z"
    />
    <path
      fill="#1abcfe"
      d="M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z"
    />
  </svg>
);

export const SassIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 24 24"
    fill="#cc6699"
  >
    <path d="M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2M10,15.33a2.55,2.55,0,0,1,0,1.5c0,.05,0,.1-.06.17s0,.07-.07.12a2.5,2.5,0,0,1-.46.67c-.58.64-1.41.88-1.74.68s-.17-1.12.49-1.83a6.91,6.91,0,0,1,1.76-1.26h0l.08-.05m8.27-9c-.45-1.78-3.4-2.36-6.18-1.37A14,14,0,0,0,7.34,7.63c-1.53,1.44-1.78,2.69-1.68,3.21.34,1.84,2.88,3.05,3.92,3.94h0c-.3.15-2.54,1.28-3.08,2.44A1.62,1.62,0,0,0,7,19.45a3.16,3.16,0,0,0,3.41-1.38A3.44,3.44,0,0,0,10.75,15a4.34,4.34,0,0,1,1.53-.08c1.76.21,2.1,1.3,2,1.76a1.16,1.16,0,0,1-.55.79c-.12.07-.16.1-.15.16s.07.08.17.06a1.36,1.36,0,0,0,1-1.22c0-1.08-1-2.28-2.81-2.25a4.84,4.84,0,0,0-1.56.22l-.08-.09c-1.13-1.2-3.21-2-3.12-3.67,0-.59.23-2.13,4-4,3.08-1.54,5.55-1.12,6-.17.61,1.33-1.32,3.82-4.52,4.18a2.44,2.44,0,0,1-2-.51c-.17-.17-.19-.2-.25-.17s0,.23,0,.33a2,2,0,0,0,1.15.91,6.18,6.18,0,0,0,3.76-.37C17.2,10.12,18.72,8,18.27,6.28Z" />
  </svg>
);

export const TailwindIcon = (
  <svg
    height="50px"
    width="50px"
    className="mt-auto mb-auto"
    version="1.1"
    viewBox="0 0 15 15"
    fill="#16becb"
  >
    <path d="M7.50006 2.5C6.47409 2.5 5.59203 2.77691 4.89966 3.37037C4.21227 3.95956 3.76259 4.81729 3.51314 5.88638C3.45869 6.1197 3.57742 6.35885 3.79619 6.45654C4.01496 6.55423 4.27228 6.483 4.40967 6.28672C4.7263 5.8344 5.04244 5.56261 5.3462 5.42313C5.64038 5.28805 5.95748 5.26068 6.32069 5.35797C6.68723 5.45615 6.97097 5.74369 7.41643 6.22816L7.43082 6.24382C7.76661 6.60905 8.17623 7.0546 8.73649 7.40028C9.31785 7.75898 10.0413 7.99999 11.0001 7.99999C12.026 7.99999 12.9081 7.72307 13.6005 7.12962C14.2878 6.54043 14.7375 5.6827 14.987 4.61361C15.0414 4.38029 14.9227 4.14114 14.7039 4.04345C14.4852 3.94576 14.2278 4.01698 14.0904 4.21326C13.7738 4.66559 13.4577 4.93737 13.1539 5.07686C12.8597 5.21194 12.5426 5.23931 12.1794 5.14202C11.8129 5.04384 11.5291 4.7563 11.0837 4.27182L11.0693 4.25616C10.7335 3.89093 10.3239 3.44538 9.76362 3.09971C9.18227 2.74101 8.45883 2.5 7.50006 2.5Z" />
    <path d="M4.00006 6.99999C2.97409 6.99999 2.09203 7.2769 1.39966 7.87036C0.712271 8.45955 0.262592 9.31727 0.0131365 10.3864C-0.0413057 10.6197 0.0774162 10.8588 0.296186 10.9565C0.514956 11.0542 0.772276 10.983 0.909673 10.7867C1.2263 10.3344 1.54244 10.0626 1.8462 9.92312C2.14038 9.78804 2.45747 9.76067 2.82069 9.85796C3.18723 9.95614 3.47097 10.2437 3.91643 10.7282L3.93082 10.7438C4.2666 11.109 4.67624 11.5546 5.23649 11.9003C5.81785 12.259 6.54128 12.5 7.50006 12.5C8.52602 12.5 9.40808 12.2231 10.1005 11.6296C10.7878 11.0404 11.2375 10.1827 11.487 9.1136C11.5414 8.88027 11.4227 8.64113 11.2039 8.54343C10.9852 8.44574 10.7278 8.51697 10.5904 8.71325C10.2738 9.16558 9.95768 9.43736 9.65391 9.57684C9.35974 9.71192 9.04264 9.7393 8.67942 9.64201C8.31289 9.54383 8.02915 9.25628 7.58369 8.77181L7.56929 8.75615C7.23351 8.39092 6.82388 7.94537 6.26362 7.59969C5.68227 7.241 4.95883 6.99999 4.00006 6.99999Z" />
  </svg>
);

export const AntDesign = (
  <svg
    height="50px"
    width="50px"
    viewBox="0 0 200 200"
    version="1.1"
    className="mt-auto mb-auto skill-logo skill-logo-ant"
  >
    <defs>
      <linearGradient
        x1="62.1023273%"
        y1="0%"
        x2="108.19718%"
        y2="37.8635764%"
        id="linearGradient-1"
      >
        <stop stopColor="#4285EB" offset="0%" />
        <stop stopColor="#2EC7FF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="69.644116%"
        y1="0%"
        x2="54.0428975%"
        y2="108.456714%"
        id="linearGradient-2"
      >
        <stop stopColor="#29CDFF" offset="0%" />
        <stop stopColor="#148EFF" offset="37.8600687%" />
        <stop stopColor="#0A60FF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="69.6908165%"
        y1="-12.9743587%"
        x2="16.7228981%"
        y2="117.391248%"
        id="linearGradient-3"
      >
        <stop stopColor="#FA816E" offset="0%" />
        <stop stopColor="#F74A5C" offset="41.472606%" />
        <stop stopColor="#F51D2C" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="68.1279872%"
        y1="-35.6905737%"
        x2="30.4400914%"
        y2="114.942679%"
        id="linearGradient-4"
      >
        <stop stopColor="#FA8E7D" offset="0%" />
        <stop stopColor="#F74A5C" offset="51.2635191%" />
        <stop stopColor="#F51D2C" offset="100%" />
      </linearGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="logo" transform="translate(-20.000000, -20.000000)">
        <g id="Group-28-Copy-5" transform="translate(20.000000, 20.000000)">
          <g id="Group-27-Copy-3">
            <g id="Group-25" fillRule="nonzero">
              <g id="2">
                <path
                  d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C99.2571609,26.9692191 101.032305,26.9692191 102.20193,28.1378823 L129.985225,55.8983314 C134.193707,60.1033528 141.017005,60.1033528 145.225487,55.8983314 C149.433969,51.69331 149.433969,44.8756232 145.225487,40.6706018 L108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                  id="Shape"
                  fill="url(#linearGradient-1)"
                />
                <path
                  d="M91.5880863,4.17652823 L4.17996544,91.5127728 C-0.519240605,96.2081146 -0.519240605,103.791885 4.17996544,108.487227 L91.5880863,195.823472 C96.2872923,200.518814 103.877304,200.518814 108.57651,195.823472 L145.225487,159.204632 C149.433969,154.999611 149.433969,148.181924 145.225487,143.976903 C141.017005,139.771881 134.193707,139.771881 129.985225,143.976903 L102.20193,171.737352 C101.032305,172.906015 99.2571609,172.906015 98.0875359,171.737352 L28.285908,101.993122 C27.1162831,100.824459 27.1162831,99.050775 28.285908,97.8821118 L98.0875359,28.1378823 C100.999864,25.6271836 105.751642,20.541824 112.729652,19.3524487 C117.915585,18.4685261 123.585219,20.4140239 129.738554,25.1889424 C125.624663,21.0784292 118.571995,14.0340304 108.58055,4.05574592 C103.862049,-0.537986846 96.2692618,-0.500797906 91.5880863,4.17652823 Z"
                  id="Shape"
                  fill="url(#linearGradient-2)"
                />
              </g>
              <path
                d="M153.685633,135.854579 C157.894115,140.0596 164.717412,140.0596 168.925894,135.854579 L195.959977,108.842726 C200.659183,104.147384 200.659183,96.5636133 195.960527,91.8688194 L168.690777,64.7181159 C164.472332,60.5180858 157.646868,60.5241425 153.435895,64.7316526 C149.227413,68.936674 149.227413,75.7543607 153.435895,79.9593821 L171.854035,98.3623765 C173.02366,99.5310396 173.02366,101.304724 171.854035,102.473387 L153.685633,120.626849 C149.47715,124.83187 149.47715,131.649557 153.685633,135.854579 Z"
                id="Shape"
                fill="url(#linearGradient-3)"
              />
            </g>
            <ellipse
              id="Combined-Shape"
              fill="url(#linearGradient-4)"
              cx="100.519339"
              cy="100.436681"
              rx="23.6001926"
              ry="23.580786"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const GoTo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 122.6 122.88"
    fill="#fff"
  >
    <g>
      <path d="M110.6,72.58c0-3.19,2.59-5.78,5.78-5.78c3.19,0,5.78,2.59,5.78,5.78v33.19c0,4.71-1.92,8.99-5.02,12.09 c-3.1,3.1-7.38,5.02-12.09,5.02H17.11c-4.71,0-8.99-1.92-12.09-5.02c-3.1-3.1-5.02-7.38-5.02-12.09V17.19 C0,12.48,1.92,8.2,5.02,5.1C8.12,2,12.4,0.08,17.11,0.08h32.98c3.19,0,5.78,2.59,5.78,5.78c0,3.19-2.59,5.78-5.78,5.78H17.11 c-1.52,0-2.9,0.63-3.91,1.63c-1.01,1.01-1.63,2.39-1.63,3.91v88.58c0,1.52,0.63,2.9,1.63,3.91c1.01,1.01,2.39,1.63,3.91,1.63h87.95 c1.52,0,2.9-0.63,3.91-1.63s1.63-2.39,1.63-3.91V72.58L110.6,72.58z M112.42,17.46L54.01,76.6c-2.23,2.27-5.89,2.3-8.16,0.07 c-2.27-2.23-2.3-5.89-0.07-8.16l56.16-56.87H78.56c-3.19,0-5.78-2.59-5.78-5.78c0-3.19,2.59-5.78,5.78-5.78h26.5 c5.12,0,11.72-0.87,15.65,3.1c2.48,2.51,1.93,22.52,1.61,34.11c-0.08,3-0.15,5.29-0.15,6.93c0,3.19-2.59,5.78-5.78,5.78 c-3.19,0-5.78-2.59-5.78-5.78c0-0.31,0.08-3.32,0.19-7.24C110.96,30.94,111.93,22.94,112.42,17.46L112.42,17.46z" />
    </g>
  </svg>
);
